import React from "react";
import styles from "./HomeCards.module.scss";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";

interface homeCardsProps {
  image: string;
  mobileImage:string,
  title: string;
  description: string;
  color: string;
  handleClick: () => void;
}
const HomeCards: React.FC<homeCardsProps> = ({
  image,
  title,
  description,
  color,
  handleClick,
  mobileImage
}) => {
  const isItMobile = useCheckMobileScreen();

  return (
    <div className={styles.cardWrapper} onClick={handleClick}>
      {isItMobile ? 
       <img src={mobileImage} alt={title} className="img-fluid" />:
       <img src={image} alt={title} className="img-fluid" />
      }

      <div
        className={`d-flex flex-column justify-content-between align-items-center cz-lh-20 px-md-3
       ${!isItMobile ? "px-lg-5" : "cz-px-8"}`}
      >
        <h5
          className={` text-center f-sm-s16  f-w8 f ${
            !isItMobile ? "cz-mt-20 " : "cz-mt-14"
          }`}
          style={{ color: color }}
        >
          {title}
        </h5>
        <p
          className={`font-trade-gothic-next f-w3 text-center  ${
            !isItMobile ? "cz-mb-0 " : "cz-mb-6 lh-14 f-s14 "
          }  f-sm-s14 clr-dark-grey `}
        >
          {description}
        </p>
        <div className={`align-self-center  align-items-end ${styles.iconDiv}`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="48"
            viewBox="0 0 33 32"
            fill="none"
          >
            <g clipPath="url(#clip0_7565_158)">
              <path
                d="M7.33331 16H26"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.6666 21.3333L26 16"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.6666 10.6667L26 16.0001"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_7565_158">
                <rect
                  width="32"
                  height="32"
                  fill="white"
                  transform="translate(0.666626)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default HomeCards;
